import { SshAuditEventListItem } from "./types";

export const dummyEvent = (_?: any, index: number = 0): SshAuditEventListItem => ({
  id: `dummyEvent_${index}`,
  raisedBy: undefined,
  requestedAt: undefined,
  username: undefined,
  validUntil: undefined,
  publicKey: undefined,
  signedKey: undefined
});
